"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAsyncCall = void 0;
const react_1 = require("react");
const useAsyncCall = (call) => {
    const [error, setError] = react_1.useState(null);
    const [loading, setLoading] = react_1.useState(false);
    const asyncCall = (...args) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setLoading(true);
            yield call(...args);
        }
        catch (error) {
            setError(error);
        }
        finally {
            setLoading(false);
        }
    });
    return [asyncCall, loading, error];
};
exports.useAsyncCall = useAsyncCall;
//# sourceMappingURL=use-async-call.js.map